import type { ReactElement } from "react";

import {
    StyledSignalsManagementButton,
    StyledSignalsNoData,
} from "app/pages/sales-intelligence/pages/company-analysis/containers/signals/SignalEventList/styles";

import { translate } from "app/filters/i18nFilter";

import { NoDataBanner } from "../../shared/NoDataBanner/NoDataBanner";
import SignalsManagementButton from "../SignalsManagementButton/SignalsManagementButton";

type Props = {
    isSignalListEmpty: boolean;
    onManageClick: () => void;
};

const SignalEventEmptyState = ({ isSignalListEmpty, onManageClick }: Props): ReactElement => {
    const bannerText = isSignalListEmpty
        ? "si.account-overview.signals.no-signals.all-deleted"
        : "si.account-overview.signals.no-signals";

    return (
        <StyledSignalsNoData>
            <NoDataBanner
                data-automation="signal-events-empty-content"
                text={translate(bannerText)}
                height={isSignalListEmpty ? "138px" : undefined}
            >
                {isSignalListEmpty ? (
                    <StyledSignalsManagementButton>
                        <SignalsManagementButton onManageClick={onManageClick} />
                    </StyledSignalsManagementButton>
                ) : null}
            </NoDataBanner>
        </StyledSignalsNoData>
    );
};

export default SignalEventEmptyState;
